module.exports = __webpack_public_path__ + "static/media/head.981ecf14.jpg";